import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import styled from 'styled-components';

const StyledTitle = styled.h3`
  text-align: left;
  font-family: ${({ theme }) => theme.fonts.mainFont};
  font-size: 1.9em;
  font-weight: 800;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: normal;
  color: ${({ theme }) => theme.colors.textPrimary};
  max-width: 92%;
  position: relative;
  display: block;
  margin: 0;

  .title_component_form {
    padding-bottom: 20px;
    position: inherit;
    text-align: center;
  }

  .title_component_alone {
    text-align: left;
    position: relative;
  }
`;

function Title({ label, className }) {
  const classes = classnames('title_component', { [className]: !!className });
  return <StyledTitle className={classes}>{label}</StyledTitle>;
}

Title.propTypes = {
  label: PropTypes.string,
  className: PropTypes.string,
};

Title.defaultProps = {
  className: '',
};

export default Title;
